export default "__VITE_ASSET__BnIcRxIB__"